import React, { useEffect, useState } from "react";
import {
  Typography,
  Table,
  TableBody,
  TableRow,
  TableCell,
  TextField,
  Select,
  MenuItem,
} from "@mui/material";

const tdLabelSx = {
  width: 180,
  bgcolor: "#f3f3f3",
  borderRight: "1px solid #e0e0e0",
  color: "#333",
  fontWeight: 600,
};

const tdFieldSx = { p: 1 };

const authHeaders = () => {
  const token =
    localStorage.getItem("access") ||
    localStorage.getItem("access_token") ||
    localStorage.getItem("token") ||
    "";

  return token ? { Authorization: `Bearer ${token}` } : {};
};

const InfoMotion = ({ onChange }) => {
  const [bodegas, setBodegas] = useState([]);

  const [data, setData] = useState({
    bodega_id: "",
    bodega: "",
    tipo: "INGRESO",
    fecha: "",
    referencia: "",
    descripcion: "",
    responsable_nombre: "",
    responsable_email: "",
  });

  useEffect(() => {
    const loadDefaults = async () => {
      try {
        const r = await fetch("/inventario/defaults/", {
          method: "GET",
          headers: {
            ...authHeaders(),
          },
        });

        const j = await r.json().catch(() => ({}));

        if (r.ok) {
          const lista = Array.isArray(j.bodegas) ? j.bodegas : [];

          const defaultId =
            j?.bodega_default?.id ||
            lista.find((b) => b.es_principal)?.id ||
            lista[0]?.id ||
            "";

          setBodegas(lista);

          setData((prev) => ({
            ...prev,
            bodega_id: defaultId ? String(defaultId) : "",
            bodega: defaultId ? String(defaultId) : "",
            fecha: j.fecha || "",
            responsable_nombre: j.responsable_nombre || "",
            responsable_email: j.responsable_email || "",
          }));
        }
      } catch {
        setBodegas([]);
      }
    };

    loadDefaults();
  }, []);

  useEffect(() => {
    onChange?.((prev) => ({
      ...(prev || {}),
      inventario: { ...data },
    }));
  }, [data, onChange]);

  const h = (f) => (e) => {
    const value = e.target.value;

    setData((p) => ({
      ...p,
      [f]: value,
      ...(f === "bodega_id" ? { bodega: value } : {}),
    }));
  };

  return (
    <>
      <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
        Información del Movimiento
      </Typography>

      <Table>
        <TableBody>
          <TableRow>
            <TableCell sx={tdLabelSx}>Bodega:</TableCell>
            <TableCell sx={tdFieldSx} colSpan={3}>
              <Select
                value={data.bodega_id}
                onChange={h("bodega_id")}
                size="small"
                sx={{ width: 280 }}
                displayEmpty
              >
                <MenuItem value="" disabled>
                  Seleccione bodega
                </MenuItem>
                {bodegas.map((b) => (
                  <MenuItem key={b.id} value={String(b.id)}>
                    {b.nombre}
                  </MenuItem>
                ))}
              </Select>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>Fecha:</TableCell>
            <TableCell sx={tdFieldSx} colSpan={3}>
              <TextField
                type="date"
                value={data.fecha}
                onChange={h("fecha")}
                size="small"
                sx={{ width: 220 }}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>Movimiento:</TableCell>
            <TableCell sx={tdFieldSx} colSpan={3}>
              <Select
                value={data.tipo}
                onChange={h("tipo")}
                size="small"
                sx={{ width: 280 }}
              >
                <MenuItem value="INGRESO">Ingreso</MenuItem>
                <MenuItem value="SALIDA">Salida</MenuItem>
              </Select>
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>Referencia:</TableCell>
            <TableCell sx={tdFieldSx} colSpan={3}>
              <TextField
                value={data.referencia}
                onChange={h("referencia")}
                size="small"
                sx={{ width: 350 }}
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>
              Descripción <span style={{ color: "red" }}>*</span>
            </TableCell>
            <TableCell sx={tdFieldSx} colSpan={3}>
              <TextField
                value={data.descripcion}
                onChange={h("descripcion")}
                size="small"
                fullWidth
                required
              />
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell sx={tdLabelSx}>Responsable:</TableCell>
            <TableCell sx={tdFieldSx} colSpan={3}>
              <TextField
                value={data.responsable_nombre || data.responsable_email}
                size="small"
                fullWidth
                InputProps={{ readOnly: true }}
              />
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
};

export default InfoMotion;